import { useRef } from "react";
import { Box } from "@mui/material";
import { FaCloudUploadAlt } from 'react-icons/fa';
import { Input,FormFeedback } from "reactstrap";

const FileUploadField = ({ label, name, fileUrl, fileValue, showError, onChange }) => {
    const inputRef = useRef();
  
    const handleClick = () => {
      inputRef.current?.click();
    };
  
    return (
      <Box sx={{ flexDirection: "column" }}>
        <label style={{ color: "#000" }}>{label}</label>
        <div
          onClick={handleClick}
          style={{
            display: 'flex',
            alignItems: 'center',
            border: '1px solid #dcdcdc',
            borderRadius: '7px',
            overflow: 'hidden',
            width: '100%',
            cursor: 'pointer',
          }}
        >
          <div
            style={{
              backgroundColor: '#a3cc00',
              padding: '9px 20px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FaCloudUploadAlt size={18} color="white" />
          </div>
          <div style={{ padding: '5px 20px' }}>
            <span style={{ fontSize: '16px' }}>{fileValue ? "Change File" : "Upload File"}</span>
          </div>
        </div>
  
        <Input
          innerRef={inputRef}
          type="file"
          name={name}
          onChange={onChange}
          invalid={showError && fileValue === ""}
          style={{ display: 'none' }}
        />
  
        {showError && fileValue === "" && (
          <FormFeedback>Image is required</FormFeedback>
        )}
      </Box>
    );
  };
  
  export default FileUploadField